export default __webpack_public_path__ + "static/media/DownloadSwitcher.b642269b.png";